<template>
  <div v-show="show" class="eu-policy-alert">
    <div v-show="!choiceShow" class="eu-policy-alert-inner">
      <div class="eu-policy-alert-top">
        <span class="eu-policy-alert-title">{{
          transify['EU_TITLE_PRIVACY'] || 'EU_TITLE_PRIVACY'
        }}</span>
      </div>
      <div id="alert-id" class="eu-policy-alert-content" v-html="content"></div>
      <div class="eu-policy-alert-bottom">
        <div class="eu-policy-alert-more" @click="more">
          {{ transify['EU_MORE'] || 'EU_MORE' }}
        </div>
        <div class="eu-policy-alert-reject" @click="reject">
          {{ transify['EU_REJECT'] || 'EU_REJECT' }}
        </div>
        <div class="eu-policy-alert-accept" @click="accept">
          {{ transify['EU_ALLOW'] || 'EU_ALLOW' }}
        </div>
      </div>
    </div>
    <div
      v-show="choiceShow"
      class="eu-policy-alert-inner eu-policy-alert-inner-choice"
    >
      <i class="eu-policy-close-icon" @click="close"></i>
      <div class="eu-policy-alert-top">
        <span class="eu-policy-alert-title">{{
          transify['EU_TITLE_PREFER'] || 'EU_TITLE_PREFER'
        }}</span>
      </div>
      <div
        id="choice-id"
        class="eu-policy-alert-content eu-policy-alert-choice"
      >
        <div
          class="eu-policy-alert-choice-item"
          @click="
            storageChecked = !storageChecked
          "
        >
          <div class="eu-policy-alert-choice-left">
            <div class="eu-policy-alert-choice-selector">
              <div
                v-show="storageChecked"
                class="eu-policy-alert-choice-checked"
              ></div>
            </div>
          </div>
          <div class="eu-policy-alert-choice-text" v-html="storageText"></div>
        </div>
        <div
          class="eu-policy-alert-choice-item"
          @click="
            adChecked = !adChecked
          "
        >
          <div class="eu-policy-alert-choice-left">
            <div class="eu-policy-alert-choice-selector">
              <div
                v-show="adChecked"
                class="eu-policy-alert-choice-checked"
              ></div>
            </div>
          </div>
          <div class="eu-policy-alert-choice-text" v-html="adText"></div>
        </div>
      </div>
      <div class="eu-policy-alert-bottom">
        <div class="eu-policy-alert-accept" @click="confirm">
          {{ transify['EU_CONFIRM'] || 'EU_CONFIRM' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { addGA } from '../../utils/ga'
import { updateConsentGA } from '../../utils/eu_popup'
import gaTool from '../../utils/ga'
const addGA = gaTool.addGA
export default {
  props: {
    content: String,
    show: Boolean,
    storageText: String,
    adText: String
  },
  data () {
    return {
      transify:null,
      choiceShow: false,
      storageChecked: true,
      adChecked: true,
      choice: {
        ad_storage: 0,
        analytics_storage: 0,
        ad_user_data: 0,
        ad_personalization: 0
      }
    }
  },
  methods: {
    onUpdateShow (value) {
      this.$emit('update:show', value)
      if (!value) {
      }
    },
    setChoice (value1, value2, value3, value4) {
      this.choice = {
        ad_storage: value1,
        analytics_storage: value2,
        ad_user_data: value3,
        ad_personalization: value4
      }
    },
    more () {
      addGA('euPolicyMore', true)
      this.choiceShow = true
      this.$nextTick(() => {
        const el = document.querySelector('#choice-id')
        el && (el.scrollTop = 0)
      })
    },
    reject () {
      this.setChoice(0, 0, 0, 0)
       this.$request.post(this.$api.googlePolicyCheck,this.choice).then(() => {
        updateConsentGA(this.choice)
        this.onUpdateShow(false)
        addGA('euPolicyReject', true)
      })
    },
    accept () {
      this.setChoice(1, 1, 1, 1)
       this.$request.post(this.$api.googlePolicyCheck,this.choice).then(() => {
        updateConsentGA(this.choice)
        this.onUpdateShow(false)
        addGA('euPolicyReject', true)
      })
    },
    confirm () {
      if (this.storageChecked && this.adChecked) {
        this.setChoice(1, 1, 1, 1)
      } else if (!this.storageChecked && !this.adChecked) {
        this.setChoice(0, 0, 0, 0)
      } else if (!this.storageChecked && this.adChecked) {
        this.setChoice(1, 0, 1, 1)
      } else if (this.storageChecked && !this.adChecked) {
        this.setChoice(0, 1, 0, 0)
      }
       this.$request.post(this.$api.googlePolicyCheck,this.choice).then(() => {
        updateConsentGA(this.choice)
        this.onUpdateShow(false)
        addGA('euPolicyConfirm', true)
      })
    },
    close () {
      this.choiceShow = false
      addGA('euPolicyCloseChoice', true)
      this.$nextTick(() => {
        const el = document.querySelector('#alert-id')
        el && (el.scrollTop = 0)
      })
    }
  },
  created() {
    if (this.globalConfig) { 
      this.transify = this.globalConfig.transify
      console.log(this.transify)
    }
  },
  mounted() {
    console.log('mounted')
  }
}
</script>

<style lang="scss">
.eu-policy-alert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1200;
  background-color: rgba(0, 0, 0, 1);
}

.eu-policy-close-icon {
  position: absolute;
  top: 0;
  right: -7%;
  @include px2res(width, 55);
  @include px2res(height, 52);
  display: inline-block;
  background-size: 100% auto;
}

.eu-policy-alert-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  @include px2res(width, 856);
  @include px2res(height, 478);
  @include px2res(border-bottom, 4, 'solid', '#6f6f6f');
  background-color: #343434;
  transition: all 0.3s ease-in-out;
}

.eu-policy-alert-top {
  position: relative;
  width: 100%;
  @include px2res(height, 68);
  @include flexrc;
  @include px2res(font-size, 50);
  background-image: linear-gradient(to bottom, #b1b1b1, #f7f5ed);

  &::after {
    content: '';
    position: absolute;
    @include px2res(bottom, 1);
    width: 70%;
    @include px2res(height, 4);
    background: linear-gradient(
      to right,
      rgba(255, 242, 146, 0) 0%,
      rgba(255, 242, 146, 1) 20%,
      rgba(255, 242, 146, 1) 50%,
      rgba(255, 242, 146, 1) 80%,
      rgba(255, 242, 146, 0) 100%
    );
    filter: drop-shadow(0 0.1em 0.05em rgba(228, 149, 18, 0.3));
  }
}

.eu-policy-alert-title {
  @include px2res(margin-top, 4);
  @include text-gradient(to bottom, #353332, #836133);
  // font-weight: 700;
  @include px2res(font-size, 50);
}

.eu-policy-alert-content {
  @include px2res(width, 796);
  @include px2res(height, 268);
  @include px2res(font-size, 28);
  @include px2res(margin, 26, 'auto');
  @include px2res(padding, 5, 20);
  font-family: inherit !important;
  overflow: hidden;
  overflow-y: auto;
  background-color: #444444;

  * {
    font-family: inherit !important;
    font-style: normal !important;
    text-decoration: none !important;
    line-height: 1.5;
  }

  p {
    font-family: inherit !important;
    color: #c9c9c9;
  }

  a {
    text-decoration: underline !important;
    color: #f0b84e;
  }

  &::-webkit-scrollbar:vertical {
    width: 0.5vw;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #8f8f8f;
  }

  &::-webkit-scrollbar-track {
    background-color: #161616;
  }
}

.eu-policy-alert-choice {
  @include px2res(padding, 20, 40);
}

.eu-policy-alert-choice-item {
  display: flex;
  // align-items: center;
  word-break: break-word;
  @include px2res(margin-bottom, 30);
}
.eu-policy-alert-choice-item:nth-child(2) {
  @include px2res(margin-bottom, 0, !important);
}

.eu-policy-alert-choice-left {
  display: inline-block;
  @include px2res(padding-top, 8);
}

.eu-policy-alert-choice-selector {
  @include px2res(width, 24);
  @include px2res(height, 24);
  border: 1px solid #cbbfa2;
  border-radius: 50%;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  @include px2res(margin-right, 10);
  flex-grow: 0;
  flex-shrink: 0;
  // display: inline-block;
}

.eu-policy-alert-choice-checked {
  @include px2res(width, 12);
  @include px2res(height, 12);
  border-radius: 50%;
  background-image: linear-gradient(to bottom, #e5d48f, #9e6722);
}

.eu-policy-alert-choice-text {
  display: inline-block;
}

.eu-policy-alert-bottom {
  @include flexrc;
}

.eu-policy-alert-reject,
.eu-policy-alert-accept,
.eu-policy-alert-more {
  @include flexrc;
  @include px2res(width, 233);
  @include px2res(height, 62);
  @include px2res(margin, 0, 18);
  @include px2res(font-size, 32);
  @include px2res(border-radius, 4);
}

.eu-policy-alert-more {
  color: #002757;
  background-image: linear-gradient(to bottom, #008dc1, #007297);
  border: 1px solid #00c6e0;
}

.eu-policy-alert-accept,
.eu-policy-alert-reject {
  color: #753f00;
  background-image: linear-gradient(to bottom, #fbed65, #f0b64d);
  border: 1px solid #f8db74;
}

@media screen and (orientation: portrait) {
  //横屏
  .eu-policy-alert-inner {
    @include px2res(width, 654);
    @include px2res(height, 796);
  }

  .eu-policy-alert-top {
    @include px2res(height, 68);
    @include px2res(font-size, 50);
  }

  .eu-policy-alert-title {
    @include px2res(margin-top, 4);
    @include px2res(font-size, 30);
  }

  .eu-policy-alert-content {
    @include px2res(width, 608);
    @include px2res(height, 436);
    @include px2res(font-size, 28);
    @include px2res(margin, 20, 'auto', 12, 'auto');
    @include px2res(padding, 10, 20);
  }

  .eu-policy-alert-choice {
    @include px2res(padding, 20, 40);
  }

  .eu-policy-alert-choice-item {
    @include px2res(margin-bottom, 30);
  }

  .eu-policy-alert-choice-left {
    @include px2res(padding-top, 8);
  }

  .eu-policy-alert-choice-selector {
    @include px2res(width, 24);
    @include px2res(height, 24);
    @include px2res(margin-right, 10);
  }

  .eu-policy-alert-choice-checked {
    @include px2res(width, 12);
    @include px2res(height, 12);
  }

  .eu-policy-alert-bottom {
    flex-direction: column;
    align-items: space-between;
  }

  .eu-policy-alert-reject,
  .eu-policy-alert-accept,
  .eu-policy-alert-more {
    @include px2res(width, 608);
    @include px2res(height, 62);
    @include px2res(margin, 10, 0);
    @include px2res(font-size, 36);
    @include px2res(border-radius, 4);
  }

  .eu-policy-close-icon {
    position: absolute;
    top: -12%;
    right: 0;
    @include px2res(width, 55);
    @include px2res(height, 52);
  }

  .eu-policy-alert-inner-choice {
    @include px2res(width, 654);
    @include px2res(height, 460);

    .eu-policy-alert-content {
      @include px2res(height, 268);
    }

    .eu-policy-alert-accept {
      @include px2res(width, 233);
    }
  }
}
</style>

<style lang="scss">
body[data-lang='tr'] {
  .eu-policy-alert-reject,
  .eu-policy-alert-accept,
  .eu-policy-alert-more {
    @include px2res(font-size, 26, !important);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/EuPolicyAlert.vue